import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const Spinner = (props) => (
    <div className={`spinner ${props.customClass ? props.customClass : ''}`}>
        <div className="box">
            <div>
                <span>&nbsp;</span>
                <p>Carregando, aguarde...</p>
            </div>
        </div>
    </div>
);

Spinner.propTypes = exact({
    customClass: PropTypes.string,
});

export default Spinner;
